import { createSelector } from 'reselect'
import isEmpty from 'lodash.isempty'

export const selectConsentMatrix = (state) => state.consents.matrix
export const selectConsentMatrixLoading = (state) => state.consents.matrixLoading
export const selectConsentStatus = (state) => state.consents.status
export const selectConsentRegion = (state) => state.user.gdpr_region

export const selectConfirmCountry = (state) => state.consents.confirmCountry

export const selectConsentScreen = createSelector(
  selectConsentStatus,
  (status) => {
    switch (status.status) {
      case 'AGE_GATE_FAIL':
        return 'AGE_GATE'
      case 'NEVER_CONSENTED':
        return 'COUNTRY_CONFIRMATION'
      case 'MISSING_TOS':
        return 'TERMS_OF_SERVICE'
      case 'NEW_USER':
      case 'MISSING_REQUIRED':
        return 'CONSENTS_REQUIRED'
      default:
        return 'error'
    }
  }
)

export const selectConsentIsoCodes = createSelector(
  selectConsentMatrix,
  (matrix) => {
    if (!isEmpty(matrix)) {
      return Object.keys(matrix.isoCodeToStandard)
    }
  },
)

export const selectConsentContent = createSelector(
  selectConsentStatus,
  (consentStatus) => {
    if (!isEmpty(consentStatus)) {
      const tosContent = consentStatus.selections.unselected.tos.map(consentType => {
        return consentStatus.content[consentType]
      })
      const requiredContent = consentStatus.selections.unselected.required.map(consentType => {
        return consentStatus.content[consentType]
      })
      const { status, consentMatrixVersion, gdprIsoCode, selections: { accepted }} = consentStatus
      return { tosContent, requiredContent, status, consentMatrixVersion, gdprIsoCode, accepted }
    }
    return {}
  },
)

export const selectAcceptedConsents = createSelector(
  selectConsentStatus,
  (consentStatus) => {
    if (!isEmpty(consentStatus)) {
      const acceptedContent = consentStatus.selections.accepted.required.map(consentType => {
        return consentStatus.content[consentType]
      })
      const { status, consentMatrixVersion, gdprIsoCode } = consentStatus
      return { acceptedContent, status, consentMatrixVersion, gdprIsoCode }
    }
    return {}
  },
)




// WEBPACK FOOTER //
// ./src/services/consents/selectors.js